import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import _intlMessageformat from "intl-messageformat";
import { useIsSSR } from "@react-aria/ssr";
import _react, { useEffect, useState, useContext, useCallback, useRef } from "react";
var $d26e725ad56fbcb2c25f52b7de27$var$RTL_SCRIPTS = new Set(['Arab', 'Syrc', 'Samr', 'Mand', 'Thaa', 'Mend', 'Nkoo', 'Adlm', 'Rohg', 'Hebr']);
var $d26e725ad56fbcb2c25f52b7de27$var$RTL_LANGS = new Set(['ae', 'ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'he', 'ku', 'mzn', 'nqo', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi']);

function $d26e725ad56fbcb2c25f52b7de27$export$isRTL(locale) {
  if (Intl.Locale) {
    var script = new Intl.Locale(locale).maximize().script;
    return $d26e725ad56fbcb2c25f52b7de27$var$RTL_SCRIPTS.has(script);
  }

  var lang = locale.split('-')[0];
  return $d26e725ad56fbcb2c25f52b7de27$var$RTL_LANGS.has(lang);
}

function $d26e725ad56fbcb2c25f52b7de27$export$numberFormatSignDisplayPolyfill(numberFormat, signDisplay, num) {
  if (signDisplay === 'auto') {
    return numberFormat.format(num);
  } else if (signDisplay === 'never') {
    return numberFormat.format(Math.abs(num));
  } else {
    var needsPositiveSign = false;

    if (signDisplay === 'always') {
      needsPositiveSign = num > 0 || Object.is(num, 0);
    } else if (signDisplay === 'exceptZero') {
      if (Object.is(num, -0) || Object.is(num, 0)) {
        num = Math.abs(num);
      } else {
        needsPositiveSign = num > 0;
      }
    }

    if (needsPositiveSign) {
      var negative = numberFormat.format(-num);
      var noSign = numberFormat.format(num);
      var minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');

      if (_toConsumableArray(minus).length !== 1) {
        console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
      }

      var positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
      return positive;
    } else {
      return numberFormat.format(num);
    }
  }
}

function $e851d0b81d46abd5f971c8e95c27f1$export$getDefaultLocale() {
  var locale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
  return {
    locale: locale,
    direction: $d26e725ad56fbcb2c25f52b7de27$export$isRTL(locale) ? 'rtl' : 'ltr'
  };
}

var $e851d0b81d46abd5f971c8e95c27f1$var$currentLocale = $e851d0b81d46abd5f971c8e95c27f1$export$getDefaultLocale();
var $e851d0b81d46abd5f971c8e95c27f1$var$listeners = new Set();

function $e851d0b81d46abd5f971c8e95c27f1$var$updateLocale() {
  $e851d0b81d46abd5f971c8e95c27f1$var$currentLocale = $e851d0b81d46abd5f971c8e95c27f1$export$getDefaultLocale();

  for (var _iterator = _createForOfIteratorHelperLoose($e851d0b81d46abd5f971c8e95c27f1$var$listeners), _step; !(_step = _iterator()).done;) {
    var listener = _step.value;
    listener($e851d0b81d46abd5f971c8e95c27f1$var$currentLocale);
  }
}

function $e851d0b81d46abd5f971c8e95c27f1$export$useDefaultLocale() {
  var isSSR = useIsSSR();

  var _useState = useState($e851d0b81d46abd5f971c8e95c27f1$var$currentLocale),
      _useState2 = _slicedToArray(_useState, 2),
      defaultLocale = _useState2[0],
      setDefaultLocale = _useState2[1];

  useEffect(function () {
    if ($e851d0b81d46abd5f971c8e95c27f1$var$listeners.size === 0) {
      window.addEventListener('languagechange', $e851d0b81d46abd5f971c8e95c27f1$var$updateLocale);
    }

    $e851d0b81d46abd5f971c8e95c27f1$var$listeners.add(setDefaultLocale);
    return function () {
      $e851d0b81d46abd5f971c8e95c27f1$var$listeners.delete(setDefaultLocale);

      if ($e851d0b81d46abd5f971c8e95c27f1$var$listeners.size === 0) {
        window.removeEventListener('languagechange', $e851d0b81d46abd5f971c8e95c27f1$var$updateLocale);
      }
    };
  }, []);

  if (isSSR) {
    return {
      locale: 'en-US',
      direction: 'ltr'
    };
  }

  return defaultLocale;
}

var $cff8541df3b5c83067b2ab3ee0d20$var$I18nContext = _react.createContext(null);

export function I18nProvider(props) {
  var locale = props.locale,
      children = props.children;
  var defaultLocale = $e851d0b81d46abd5f971c8e95c27f1$export$useDefaultLocale();
  var value = locale ? {
    locale: locale,
    direction: $d26e725ad56fbcb2c25f52b7de27$export$isRTL(locale) ? 'rtl' : 'ltr'
  } : defaultLocale;
  return _react.createElement($cff8541df3b5c83067b2ab3ee0d20$var$I18nContext.Provider, {
    value: value
  }, children);
}
export function useLocale() {
  var defaultLocale = $e851d0b81d46abd5f971c8e95c27f1$export$useDefaultLocale();
  var context = useContext($cff8541df3b5c83067b2ab3ee0d20$var$I18nContext);
  return context || defaultLocale;
}
var $f58d206cee90f9c2bf3c03e4522c35$var$formatterCache = new Map();
export function useMessageFormatter(strings) {
  var _useLocale = useLocale(),
      currentLocale = _useLocale.locale;

  var localeCache = $f58d206cee90f9c2bf3c03e4522c35$var$formatterCache.get(strings);

  if (localeCache && localeCache.has(currentLocale)) {
    return localeCache.get(currentLocale);
  }

  if (!localeCache) {
    localeCache = new Map();
    $f58d206cee90f9c2bf3c03e4522c35$var$formatterCache.set(strings, localeCache);
  }

  var localeStrings = $f58d206cee90f9c2bf3c03e4522c35$var$selectLocale(strings, currentLocale);
  var cache = {};

  var formatMessage = function formatMessage(key, variables) {
    var message = cache[key + '.' + currentLocale];

    if (!message) {
      var msg = localeStrings[key];

      if (!msg) {
        throw new Error("Could not find intl message " + key + " in " + currentLocale + " locale");
      }

      message = new _intlMessageformat(msg, currentLocale);
      cache[key] = message;
    }

    return message.format(variables);
  };

  localeCache.set(currentLocale, formatMessage);
  return formatMessage;
}

function $f58d206cee90f9c2bf3c03e4522c35$var$selectLocale(strings, locale) {
  if (strings[locale]) {
    return strings[locale];
  }

  var language = $f58d206cee90f9c2bf3c03e4522c35$var$getLanguage(locale);

  for (var key in strings) {
    if (key.startsWith(language + '-')) {
      return strings[key];
    }
  }

  return strings['en-US'];
}

function $f58d206cee90f9c2bf3c03e4522c35$var$getLanguage(locale) {
  if (Intl.Locale) {
    return new Intl.Locale(locale).language;
  }

  return locale.split('-')[0];
}

var $b0007c63a64054c318efb8b6cd0053f$var$formatterCache = new Map();
export function useDateFormatter(options) {
  var _useLocale2 = useLocale(),
      locale = _useLocale2.locale;

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');

  if ($b0007c63a64054c318efb8b6cd0053f$var$formatterCache.has(cacheKey)) {
    return $b0007c63a64054c318efb8b6cd0053f$var$formatterCache.get(cacheKey);
  }

  var formatter = new Intl.DateTimeFormat(locale, options);
  $b0007c63a64054c318efb8b6cd0053f$var$formatterCache.set(cacheKey, formatter);
  return formatter;
}
export function useNumberParser() {
  var _useLocale3 = useLocale(),
      locale = _useLocale3.locale;

  var numberData = useRef({
    group: null,
    decimal: null,
    numeral: null,
    index: null
  });
  useEffect(function () {
    var parts = new Intl.NumberFormat(locale).formatToParts(12345.6);

    var numerals = _toConsumableArray(new Intl.NumberFormat(locale, {
      useGrouping: false
    }).format(9876543210)).reverse();

    var index = new Map(numerals.map(function (d, i) {
      return [d, i];
    }));
    numberData.current.group = new RegExp("[" + parts.find(function (d) {
      return d.type === 'group';
    }).value + "]", 'g');
    numberData.current.decimal = new RegExp("[" + parts.find(function (d) {
      return d.type === 'decimal';
    }).value + "]");
    numberData.current.numeral = new RegExp("[" + numerals.join('') + "]", 'g');

    numberData.current.index = function (d) {
      return index.get(d);
    };
  }, [locale]);
  var parse = useCallback(function (value) {
    value = value.trim().replace(numberData.current.group, '').replace(numberData.current.decimal, '.').replace(numberData.current.numeral, numberData.current.index);
    return value ? +value : NaN;
  }, []);
  return {
    parse: parse
  };
}
var $ece3e138e83d330f42860705a2ec18a$var$formatterCache = new Map();
var $ece3e138e83d330f42860705a2ec18a$var$supportsSignDisplay = false;

try {
  $ece3e138e83d330f42860705a2ec18a$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
    signDisplay: 'exceptZero'
  }).resolvedOptions().signDisplay === 'exceptZero';
} catch (e) {}

export function useNumberFormatter(options) {
  var _useLocale4 = useLocale(),
      locale = _useLocale4.locale;

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');

  if ($ece3e138e83d330f42860705a2ec18a$var$formatterCache.has(cacheKey)) {
    return $ece3e138e83d330f42860705a2ec18a$var$formatterCache.get(cacheKey);
  }

  var numberFormatter = new Intl.NumberFormat(locale, options);

  var _ref = options || {},
      signDisplay = _ref.signDisplay;

  $ece3e138e83d330f42860705a2ec18a$var$formatterCache.set(cacheKey, !$ece3e138e83d330f42860705a2ec18a$var$supportsSignDisplay && signDisplay != null ? new Proxy(numberFormatter, {
    get: function get(target, property) {
      if (property === 'format') {
        return function (v) {
          return $d26e725ad56fbcb2c25f52b7de27$export$numberFormatSignDisplayPolyfill(numberFormatter, signDisplay, v);
        };
      } else {
        return target[property];
      }
    }
  }) : numberFormatter);
  return numberFormatter;
}
var $a4045a18d7252bf6de9312e613c4e$var$cache = new Map();
export function useCollator(options) {
  var _useLocale5 = useLocale(),
      locale = _useLocale5.locale;

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');

  if ($a4045a18d7252bf6de9312e613c4e$var$cache.has(cacheKey)) {
    return $a4045a18d7252bf6de9312e613c4e$var$cache.get(cacheKey);
  }

  var formatter = new Intl.Collator(locale, options);
  $a4045a18d7252bf6de9312e613c4e$var$cache.set(cacheKey, formatter);
  return formatter;
}
export function useFilter(options) {
  var collator = useCollator(_babelRuntimeHelpersEsmExtends({
    usage: 'search'
  }, options));
  return {
    startsWith: function startsWith(string, substring) {
      if (substring.length === 0) {
        return true;
      }

      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      return collator.compare(string.slice(0, substring.length), substring) === 0;
    },
    endsWith: function endsWith(string, substring) {
      if (substring.length === 0) {
        return true;
      }

      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      return collator.compare(string.slice(-substring.length), substring) === 0;
    },
    contains: function contains(string, substring) {
      if (substring.length === 0) {
        return true;
      }

      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      var scan = 0;
      var sliceLen = substring.length;

      for (; scan + sliceLen <= string.length; scan++) {
        var slice = string.slice(scan, scan + sliceLen);

        if (collator.compare(substring, slice) === 0) {
          return true;
        }
      }

      return false;
    }
  };
}